import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy, limit } from 'firebase/firestore';
import { db } from '../firebase'; // Make sure this path is correct
import './PartyOrders.css';

const PartyOrders = () => {
    const [bannerUrl, setBannerUrl] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBanner = async () => {
            try {
                // Fetch the most recent banner from the 'party_banners' collection
                const bannerQuery = query(collection(db, 'party_banners'), orderBy('createdAt', 'desc'), limit(1));
                const bannerSnapshot = await getDocs(bannerQuery);
                
                if (!bannerSnapshot.empty) {
                    const bannerData = bannerSnapshot.docs[0].data();
                    setBannerUrl(bannerData.imageUrl);
                }
            } catch (error) {
                console.error("Error fetching party banner:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchBanner();
    }, []);

    return (
        <div className="party-orders-page">
            {/* --- Hero Banner Section --- */}
            {loading ? (
                <div className="banner-placeholder"></div>
            ) : (
                bannerUrl && (
                    <div 
                        className="hero-banner" 
                        style={{ backgroundImage: `url(${bannerUrl})` }}
                        aria-label="Party orders banner"
                    ></div>
                )
            )}

            {/* --- Static Images Gallery --- */}
            <section className="gallery-section">
                <h2 className="gallery-title">Explore Our Offerings</h2>
                <div className="gallery-grid">
                    {/* ✅ CORRECTED IMAGE PATHS TO MATCH YOUR ACTUAL FILES */}
                    <div className="gallery-item">
                        <img src="/assets/images/homepage-one/image1.png" alt="Catering Buffet" />
                        <div className="gallery-item-info">
                            <h3>Full Buffet Service</h3>
                            <p>Perfect for weddings and large corporate events.</p>
                        </div>
                    </div>
                    <div className="gallery-item">
                        <img src="/assets/images/homepage-one/image2.png" alt="Snack Platters" />
                         <div className="gallery-item-info">
                            <h3>Snack Platters</h3>
                            <p>Ideal for meetings and casual get-togethers.</p>
                        </div>
                    </div>
                    <div className="gallery-item">
                        <img src="/assets/images/homepage-one/image3.png" alt="Corporate Lunch Boxes" />
                         <div className="gallery-item-info">
                            <h3>Corporate Lunch Boxes</h3>
                            <p>Individual, hygienic, and delicious meals for your team.</p>
                        </div>
                    </div>
                     <div className="gallery-item">
                        <img src="/assets/images/homepage-one/image4.png" alt="Celebration Cakes" />
                         <div className="gallery-item-info">
                            <h3>Desserts & Add-ons</h3>
                            <p>Custom cakes, sweets, and more for your event.</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default PartyOrders;